import {
  Actor,
  AgentStepModel,
  AiService,
  AssociatedIntegration,
  AssociatedThreadId,
  ActivitySource,
} from './agentStep.model';
import { LabelBindingModel } from './common';

export enum DetectionRuleTag {
  preview = 'preview',
  generalAvailability = 'generalAvailability',
  deprecated = 'deprecated',
  exploitable = 'exploitable',
  alert = 'alert',
  governance = 'governance',
  threatDetection = 'threatDetection',
}

export enum DetectionRuleAuthor {
  zenity = 'zenity',
}

export enum DetectionRuleSeverity {
  informational = 'informational',
  low = 'low',
  medium = 'medium',
  high = 'high',
  critical = 'critical',
}

export enum DetectionRisk {
  potentialPromptInjection = 'potentialPromptInjection',
}

export interface DetectionRule {
  displayName: string;
  id: string;
  description: string;
  license: string;
  references: string[];
  tags: DetectionRuleTag[];
  author: DetectionRuleAuthor;
  date: Date;
  modified: Date;
  falsePositives: string[];
  severity: DetectionRuleSeverity;
  riskLabels: DetectionRisk[];
  owasp: string[];
  genAiAttack: string[];
  fixSuggestion: string;
  triageSuggestion: string;
  summary: string;
  riskReason: string;
  service: AiService;
}

export interface Evidence {
  id?: string;
  title: string;
  stepId: string;
  coreEvidence: string;
  location: string;
  additionalData: string | Record<string, string>;
}

export type FindingAction = 'detect' | 'block';

export class FindingModel {
  public id: string;
  public rule: DetectionRule;
  public thread: AssociatedThreadId;
  public integration: AssociatedIntegration;
  public zenityAccountId: string;
  public timestamp: Date;
  public relatedSteps: AgentStepModel[];
  public evidence: Evidence[];
  public mainActor: Actor;
  public labelBindings: LabelBindingModel[];
  public source?: ActivitySource;
  public sourcePipeline?: string;
  public action?: FindingAction;
}

export interface FindingsAggregatedByServiceSeverity {
  service: string;
  severity: string;
  count: number;
}
